import React from 'react';
import { Link } from 'react-router-dom';
import platformImage from '../assests/main image.png';

const pricingComponents = [
  ['Meta Messaging Charges', 'Applicable WhatsApp Business Platform messaging charges.'],
  ['HAWKTRION Platform', 'Software and business communication features.'],
  ['API Usage', 'API-based application communication.'],
  ['Integration', 'Connecting WhatsApp with your existing systems.'],
  ['Automation', 'Business workflow requirements.'],
  ['CRM', 'Customer and lead management.'],
  ['Campaigns', 'Marketing and customer engagement workflows.'],
  ['Development', 'Custom application or integration work.'],
];
const platformPlans = [
  {
    name: 'Starter',
    amount: '₹999',
    period: '/month',
    description: 'Entry-level automation for growing brands',
    features: ['Official WhatsApp API', 'Up to 5 message templates', 'Basic analytics dashboard', 'Email support', 'Webhook integration'],
    cta: 'Get Started',
  },
  {
    name: 'Professional',
    amount: '₹2,999',
    period: '/month',
    description: 'Complete Sales & Support Engine',
    features: ['Official WhatsApp API', 'Unlimited message templates', 'Advanced analytics & ROI tracking', 'Priority 24/7 support', 'CRM integration (Salesforce, HubSpot, Zoho)', 'AI-Powered Chatbot included'],
    cta: 'Choose Plan',
    featured: true,
  },
  {
    name: 'Enterprise',
    amount: 'Custom',
    period: 'Tailored pricing',
    description: 'Unlimited messaging + custom features',
    features: ['All Professional features', 'Unlimited message volume', 'Custom AI chatbot training', 'Dedicated account manager', '99.9% SLA guarantee', 'Custom API integrations'],
    cta: 'Contact Sales',
  },
];
const pricingFactors = [
  ['Message Volume', 'A small number of customer conversations has different requirements from thousands or millions of messages.'],
  ['Message Type', 'Common communication categories include marketing, utility, authentication, and customer service. Applicable pricing and rules can change.'],
  ['Customer Conversations', 'The nature and timing of customer interactions can affect how you design messaging workflows.'],
  ['Templates', 'Business-initiated communication may require approved templates, depending on messaging rules and the customer-service window.'],
  ['Integrations', 'Connecting WhatsApp to CRM, websites, ecommerce, SaaS, or custom software can affect implementation costs.'],
];
const platformFeatures = [
  ['Messaging', 'Send supported WhatsApp messages and media.'],
  ['Templates', 'Create and manage WhatsApp message templates.'],
  ['Campaigns', 'Create and manage customer communication campaigns.'],
  ['Automation', 'Build automated WhatsApp workflows.'],
  ['CRM', 'Manage customers and leads alongside communication.'],
  ['Webhooks', 'Connect WhatsApp events with your applications.'],
  ['Developer APIs', 'Integrate WhatsApp into your own software.'],
  ['Media Messaging', 'Work with supported images, videos, documents, and audio.'],
];
const smallBusinessNeeds = ['Customer notifications', 'Appointment reminders', 'Customer support', 'Order updates', 'Basic automation', 'Lead follow-ups'];
const growingBusinessNeeds = ['Customer segmentation', 'Campaigns', 'CRM', 'Automated workflows', 'Templates', 'API integration', 'Webhooks', 'Customer analytics'];
const enterpriseNeeds = ['High-volume messaging', 'CRM integration', 'Ecommerce integration', 'ERP integration', 'Custom APIs', 'Automated workflows', 'Campaign management', 'Customer segmentation', 'Developer integrations', 'Webhooks', 'Business reporting'];
const cloudCosts = ['Platform costs', 'Integration costs', 'Development', 'Automation', 'CRM', 'Campaign management', 'Other business requirements'];
const indiaCosts = ['Messaging volume', 'Message category', 'Customer conversations', 'Business use case', 'Platform requirements', 'API integration', 'Automation', 'CRM', 'Campaigns'];
const marketingNeeds = ['Customer segmentation', 'Campaign management', 'Scheduling', 'Template management', 'Customer data', 'Analytics', 'Automation'];
const pricingVsApp = [
  ['Manual messaging', 'Yes', 'Yes, through integrated systems'],
  ['Application integration', 'Limited', 'Yes'],
  ['Developer API', 'No', 'Yes'],
  ['Webhooks', 'No', 'Yes'],
  ['Automated workflows', 'Limited', 'Yes'],
  ['CRM integration', 'Limited', 'Yes'],
  ['Campaign workflows', 'Limited', 'Yes'],
  ['Programmatic messaging', 'No', 'Yes'],
  ['SaaS integration', 'No', 'Yes'],
  ['Large-scale business workflows', 'Limited', 'Designed for integration'],
];
const estimateQuestions = [
  ['1', 'How many customers do you communicate with?', 'Estimate your monthly active customer base.'],
  ['2', 'How many messages do you send?', 'Estimate your expected monthly messaging volume.'],
  ['3', 'What type of messages do you send?', 'Identify your marketing, utility, authentication, and customer-service use cases.'],
  ['4', 'Do you need automation?', 'Determine whether messages need to be triggered automatically.'],
  ['5', 'Do you need CRM?', 'Decide whether customer and lead management should be integrated.'],
  ['6', 'Do you need API integration?', 'Determine whether your website, SaaS, ecommerce, or CRM needs direct integration.'],
  ['7', 'Do you need campaigns?', 'Identify whether you need audience management and campaign scheduling.'],
];
const includedFeatures = [
  ['WhatsApp Messaging', 'Send supported customer messages.'],
  ['Templates', 'Manage approved WhatsApp message templates.'],
  ['Campaigns', 'Create and manage customer communication campaigns.'],
  ['Automation', 'Create automated messaging workflows.'],
  ['CRM', 'Manage customers, leads, and customer information.'],
  ['Webhooks', 'Receive supported messaging events.'],
  ['APIs', 'Connect your own applications.'],
  ['Media', 'Support business workflows involving supported media types.'],
];
const platformBenefits = [
  ['Centralized Platform', 'Manage important WhatsApp workflows from one platform.'],
  ['Developer Integration', 'Connect your applications through APIs and webhooks.'],
  ['CRM', 'Organize customers and leads.'],
  ['Automation', 'Reduce repetitive manual communication.'],
  ['Campaigns', 'Create targeted customer communication campaigns.'],
  ['Templates', 'Manage WhatsApp templates.'],
  ['Scalable Architecture', 'Build workflows that can grow with your business.'],
];
const faqs = [
  ['How much does WhatsApp API cost?', 'WhatsApp API costs depend on applicable Meta messaging charges, provider or platform costs, message volume, business use case, and integration requirements.'],
  ['Is WhatsApp Cloud API free?', 'The Cloud API should not be treated as meaning all WhatsApp business messaging is free. Applicable Meta messaging charges and other platform or integration costs may apply.'],
  ['Does HAWKTRION charge for WhatsApp API?', 'HAWKTRION platform pricing depends on your business features and requirements. Contact the HAWKTRION team for current pricing and available plans.'],
  ['Does WhatsApp charge per message?', 'The applicable WhatsApp Business Platform pricing model determines how messaging is charged. Pricing can change, so check the latest official Meta pricing before calculating costs.'],
  ['How much does WhatsApp API cost in India?', 'There is no single fixed price for every business. Costs depend on applicable Meta pricing, messaging volume, message categories, platform requirements, and integration needs.'],
  ['Is WhatsApp marketing free?', 'Marketing communication can involve applicable WhatsApp Business Platform charges and platform costs. Businesses must also follow WhatsApp messaging policies and consent requirements.'],
  ['Are WhatsApp templates free?', 'Template creation and approval should be considered separately from applicable messaging charges. The cost of using a template can depend on the applicable WhatsApp pricing model and message category.'],
  ['Does WhatsApp API have a monthly fee?', 'A monthly platform fee is not necessarily the same as WhatsApp messaging charges. Overall costs may include platform subscriptions, messaging charges, integration, and development.'],
  ['What affects WhatsApp API pricing?', 'Important factors include message volume, messaging category, customer interactions, platform features, integrations, automation, and development requirements.'],
  ['Can I integrate WhatsApp API with my CRM?', 'Yes. HAWKTRION supports API and integration workflows that can connect WhatsApp communication with CRM and other business systems.'],
];

const SectionHeading = ({ eyebrow, title, children }) => (
  <div className="business-api-heading">
    {eyebrow && <div className="sec-label"><span className="sec-label-dot"></span>{eyebrow}</div>}
    <h2>{title}</h2>
    {children && <p>{children}</p>}
  </div>
);

const BulletList = ({ items }) => (
  <ul className="business-api-list">
    {items.map((item) => <li key={item}>{item}</li>)}
  </ul>
);

const CardGrid = ({ items }) => (
  <div className="business-api-grid">
    {items.map(([title, description]) => (
      <article className="business-api-card" key={title}>
        <h3>{title}</h3>
        <p>{description}</p>
      </article>
    ))}
  </div>
);

const Workflow = ({ steps }) => (
  <ol className="business-api-workflow">
    {steps.map((step, index) => (
      <li key={step}><span className="business-api-step-number">{index + 1}</span><span>{step}</span></li>
    ))}
  </ol>
);

const PricingTable = ({ caption, headers, rows }) => (
  <div className="cloud-api-table-wrap">
    <table className="cloud-api-table">
      <caption>{caption}</caption>
      <thead><tr>{headers.map((header) => <th scope="col" key={header}>{header}</th>)}</tr></thead>
      <tbody>{rows.map((row) => <tr key={row[0]}>{row.map((cell, index) => index === 0 ? <th scope="row" key={cell}>{cell}</th> : <td key={cell}>{cell}</td>)}</tr>)}</tbody>
    </table>
  </div>
);

const TierSection = ({ title, description, needs, cta, href = '/signup' }) => (
  <article className="business-api-card pricing-tier-card">
    <h3>{title}</h3>
    <p>{description}</p>
    <BulletList items={needs} />
    {cta && <a className="business-api-text-link" href={href}>{cta}</a>}
  </article>
);

const WhatsappApiPricingContent = () => (
  <div className="business-api-content pricing-content">
    <section className="business-api-section business-api-intro">
      <div className="container">
        <div className="business-api-intro-grid">
          <div className="business-api-intro-copy">
            <p className="business-api-lead">Understand WhatsApp API costs and build the right messaging solution.</p>
            <p>WhatsApp API pricing can include multiple components depending on your business, messaging use case, Meta&apos;s applicable pricing model, and the platform features you need.</p>
            <p>HAWKTRION helps businesses manage WhatsApp communication through messaging, templates, automation, campaigns, CRM, and API integration.</p>
            <div className="business-api-actions">
              <Link to="/signup" className="btn btn-p">Get Started</Link>
              <a href="mailto:support@hawktrion.com?subject=WhatsApp%20API%20Pricing" className="btn btn-s">Talk to Sales</a>
            </div>
          </div>
          <figure className="business-api-visual">
            <img src={platformImage} alt="HAWKTRION WhatsApp platform overview with messaging, CRM, automation, campaigns, and analytics" />
            <figcaption>Plan the messaging and platform capabilities your business actually needs.</figcaption>
          </figure>
        </div>
      </div>
    </section>

    <section className="business-api-section" id="pricing">
      <div className="container">
        <SectionHeading eyebrow="Pricing Plans" title={<>Choose the Plan That Fits<br />Your Messaging Volume</>}>
          Flexible pricing designed to scale with your business. All plans include setup assistance, documentation, and regular updates.
        </SectionHeading>
        <div className="pricing-grid">
          {platformPlans.map((plan) => (
            <div className={plan.featured ? 'price-featured' : 'price-card'} key={plan.name}>
              {plan.featured && <div className="price-badge">MOST POPULAR</div>}
              <h3 className="price-name">{plan.name}</h3>
              <div className="price-amount" style={plan.amount === 'Custom' ? { fontSize: '28px' } : undefined}>{plan.amount}</div>
              <div className="price-period">{plan.period}</div>
              <div className="price-desc">{plan.description}</div>
              <div className="price-divider"></div>
              <ul className="price-feats">
                {plan.features.map((feature) => <li key={feature}>{feature}</li>)}
              </ul>
              <Link
                to="/signup"
                className={plan.featured ? 'btn btn-p' : 'btn btn-s'}
                style={{
                  width: '100%',
                  justifyContent: 'center',
                  ...(plan.featured ? { boxShadow: '0 6px 28px rgba(0,167,255,.4)' } : {}),
                }}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Pricing Overview" title="How Does WhatsApp API Pricing Work?">
          WhatsApp API costs are not necessarily the same as the cost of using a regular WhatsApp application. Consider the components involved in your complete business messaging solution.
        </SectionHeading>
        <CardGrid items={[
          ['WhatsApp / Meta Messaging Charges', 'Meta determines applicable WhatsApp Business Platform messaging charges according to its current pricing model and business rules.'],
          ['Platform Costs', 'Your provider or software platform may have its own subscription, usage, or service fees.'],
          ['Integration Costs', 'Project costs may depend on integrating WhatsApp with your CRM, website, ecommerce platform, SaaS application, or custom software.'],
          ['Optional Business Features', 'Campaigns, automation, CRM, analytics, and additional integrations affect your platform requirements.'],
        ]} />
        <p className="business-api-copy pricing-disclaimer">Meta pricing and policies may change. Confirm current charges against the official <a href="https://developers.facebook.com/docs/whatsapp/pricing/" target="_blank" rel="noopener noreferrer">WhatsApp pricing documentation</a> before making financial projections.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Cost Factors" title="What Determines WhatsApp API Cost?">
          Several factors can affect the overall cost of your WhatsApp API implementation.
        </SectionHeading>
        <CardGrid items={pricingFactors} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Platform Capabilities" title="Get More Than Just API Connectivity">
          HAWKTRION provides business tools around WhatsApp communication so you do not have to build every workflow separately.
        </SectionHeading>
        <CardGrid items={platformFeatures} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Budget Planning" title="WhatsApp API Pricing Components">
          Understanding the different cost components makes it easier to plan your WhatsApp implementation.
        </SectionHeading>
        <PricingTable
          caption="Common cost components in a WhatsApp API implementation"
          headers={['Cost Component', 'What It Covers']}
          rows={pricingComponents}
        />
        <p className="business-api-copy">Your actual total cost depends on your business requirements and applicable pricing.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Estimate Your Needs" title="Is WhatsApp API Expensive?">
          It depends on your business requirements. A small business with a limited number of customer conversations has different needs from an enterprise sending high volumes of messages.
        </SectionHeading>
        <BulletList items={['Number of customers', 'Message volume', 'Messaging categories', 'Business use cases', 'Integration requirements', 'Automation requirements', 'CRM requirements', 'Campaign requirements', 'Platform features', 'Development requirements']} />
        <p className="business-api-copy">Calculate costs around your actual messaging workflow rather than relying on a generic estimate.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Business Size" title="Pricing Requirements at Every Stage">
          Start with the capabilities you need and plan for your communication to grow.
        </SectionHeading>
        <div className="business-api-grid pricing-tier-grid">
          <TierSection title="Small Businesses" description="Start with the features your business needs today." needs={smallBusinessNeeds} />
          <TierSection title="Growing Businesses" description="Add capabilities as communication requirements expand." needs={growingBusinessNeeds} />
          <TierSection title="Enterprises" description="Build a scalable communication and integration architecture." needs={enterpriseNeeds} cta="Contact HAWKTRION Sales" href="mailto:support@hawktrion.com?subject=Enterprise%20WhatsApp%20API%20Pricing" />
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Cloud API Costs" title="WhatsApp Cloud API Pricing">
          Consider Meta messaging charges separately from the software features provided by a platform such as HAWKTRION.
        </SectionHeading>
        <p className="business-api-copy">Meta&apos;s WhatsApp Business Platform pricing and messaging rules determine applicable messaging charges. Total implementation costs can additionally include:</p>
        <BulletList items={cloudCosts} />
        <p className="business-api-copy pricing-disclaimer">Because Meta pricing and policies can change, verify current pricing directly with the applicable Meta documentation before making financial projections.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="India" title="WhatsApp API Pricing in India">
          Plan for applicable WhatsApp Business Platform charges and the software and integrations used to manage business communication.
        </SectionHeading>
        <BulletList items={indiaCosts} />
        <p className="business-api-copy">HAWKTRION can help design a WhatsApp communication solution based on your actual requirements.</p>
        <a href="mailto:support@hawktrion.com?subject=WhatsApp%20API%20Pricing%20Estimate%20India" className="business-api-text-link">Get a Custom Pricing Estimate</a>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Marketing Costs" title="Plan Your WhatsApp Marketing Budget">
          Marketing costs can depend on messaging volume, applicable Meta pricing, and the platform features needed to manage campaigns.
        </SectionHeading>
        <Workflow steps={['Customer audience', 'Segmentation', 'Campaign', 'Approved template', 'WhatsApp', 'Customer']} />
        <h3 className="business-api-subheading">Additional Campaign Requirements</h3>
        <BulletList items={marketingNeeds} />
        <p className="business-api-copy">HAWKTRION brings campaign management and customer communication workflows together in one platform.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Compare Options" title="WhatsApp API Pricing vs WhatsApp Business App">
          If your business needs software integration and automated communication, an API-based solution is generally more appropriate.
        </SectionHeading>
        <PricingTable
          caption="Capabilities of the WhatsApp Business App and API integration"
          headers={['Feature', 'WhatsApp Business App', 'WhatsApp API']}
          rows={pricingVsApp}
        />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Platform Features" title="What Is Included With HAWKTRION?">
          HAWKTRION provides tools designed to help businesses manage their WhatsApp communication infrastructure.
        </SectionHeading>
        <CardGrid items={includedFeatures} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Cost Checklist" title="Calculate Your WhatsApp API Requirements">
          Answer these questions before choosing a WhatsApp API platform. Your answers can help determine the right architecture for your business.
        </SectionHeading>
        <ol className="business-api-steps">
          {estimateQuestions.map(([number, question, description]) => (
            <li className="business-api-step" key={number}>
              <span className="business-api-step-number">{number}</span>
              <div><h3>{question}</h3><p>{description}</p></div>
            </li>
          ))}
        </ol>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Why HAWKTRION" title="More Than a WhatsApp API Connection">
          HAWKTRION combines WhatsApp communication with business tools.
        </SectionHeading>
        <CardGrid items={platformBenefits} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <div className="business-api-cta-panel">
          <SectionHeading eyebrow="Custom Pricing" title="Tell Us About Your Business Requirements">
            Every business has different WhatsApp messaging requirements. Evaluate your full communication workflow rather than choosing only by message volume.
          </SectionHeading>
          <BulletList items={['Business type', 'Estimated customer count', 'Monthly message volume', 'Main WhatsApp use cases', 'Required integrations', 'CRM requirements', 'Automation requirements', 'Campaign requirements']} />
          <p className="business-api-copy">Our team can help determine the appropriate HAWKTRION setup.</p>
          <div className="business-api-actions">
            <a href="mailto:support@hawktrion.com?subject=Request%20Custom%20WhatsApp%20API%20Pricing" className="btn btn-p">Request Custom Pricing</a>
            <a href="mailto:support@hawktrion.com?subject=WhatsApp%20API%20Pricing" className="btn btn-s">Talk to Sales</a>
          </div>
        </div>
      </div>
    </section>

    <section className="business-api-section business-api-faq" id="whatsapp-api-pricing-faq">
      <div className="container">
        <SectionHeading eyebrow="Answers" title="WhatsApp API Pricing FAQs" />
        <div className="business-api-faq-list">
          {faqs.map(([question, answer]) => <details key={question}><summary>{question}</summary><p>{answer}</p></details>)}
        </div>
      </div>
    </section>

    <section className="business-api-section business-api-final-cta">
      <div className="container">
        <div className="business-api-cta-panel">
          <SectionHeading eyebrow="Get Started" title="Build a WhatsApp Solution That Fits Your Business">
            Understand your messaging requirements, choose the right architecture, and connect WhatsApp with your business applications. Manage messaging, templates, automation, campaigns, CRM, and API integrations with HAWKTRION.
          </SectionHeading>
          <div className="business-api-actions">
            <Link to="/signup" className="btn btn-p">Get Started With HAWKTRION</Link>
            <a href="mailto:support@hawktrion.com?subject=Request%20Custom%20WhatsApp%20API%20Pricing" className="btn btn-s">Request Custom Pricing</a>
          </div>
        </div>
       
      </div>
    </section>
  </div>
);

export default WhatsappApiPricingContent;